// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled, { keyframes } from 'styled-components'

const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div`
  background-color: rgba(255, 255, 255, .5);
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;

  &::before,
  &::after {
    animation: ${loadingAnimation} .7s linear infinite;
    // $blue: #335c84;
    border: thin solid #335c84;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
    bottom: 0;
    content: ' ';
    display: block;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
  }

  &::before {
    height: 4rem;
    width: 4rem;
  }

  &::after {
    animation-direction: reverse;
    height: 2rem;
    width: 2rem;
  }
`
